import React from 'react';
import cx from 'classnames';

import { getTailwindColor, scaleImage } from '@trqk/utils';

const iconId = 'music-notes';

const originalDimensions = {
    width: 24,
    height: 24,
};

export const IconMusicNotes = (props: IconProps): JSX.Element => {
    const fillColor = props?.fillColor ?? 'black';
    const fill = getTailwindColor(fillColor);
    const { height, width } = scaleImage(originalDimensions, props);
    const { addClasses } = props;

    return (
        <svg
            aria-labelledby={iconId}
            className={cx(addClasses)}
            height={height}
            viewBox={`0 0 ${originalDimensions.width} ${originalDimensions.height}`}
            width={width}
            xmlns="http://www.w3.org/2000/svg"
        >
            <title id={iconId}>Music Notes Icon</title>
            <g fill="none" fillRule="evenodd">
                <path d="M0 0h24v24H0z" />
                <path
                    d="M8 17.04V8a1 1 0 01.702-.954l9-2.5A1 1 0 0119 5.5V17c0 1.105-1.12 2-2.5 2s-2.5-.895-2.5-2 1.12-2 2.5-2c.171 0 .338.014.5.04V8l-7 1.875V19c0 1.105-1.12 2-2.5 2S5 20.105 5 19s1.12-2 2.5-2c.171 0 .338.014.5.04z"
                    fill={fill}
                    fillRule="nonzero"
                />
            </g>
        </svg>
    );
};
